import dayjs, { Dayjs } from "dayjs";

export function isValidDateOfBirth(value: Dayjs): boolean {
    const today = dayjs();

    return value.isBefore(today.subtract(125, "years"));
}
